export class RecipientFilterConstants {
    // Labels
    static displayGroupsLabel = "Display groups";
    static selectGroupsLabel = "Select group";
    static componentName = "recipient filter";
    static selectAllFromGroupBtnLabel = "Select all from group";
}
